import React, { useState } from 'react'
import { Card, Button, Form } from 'react-bootstrap'

// 3rd party and libraries
import _ from 'lodash'

// icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import { MdDateRange } from 'react-icons/md'

// componnt and constants
import DeliveryLists from './DeliveryLists'
import CurrentDateModal from '../../components/currentComponent/CurrentDateModal'
import { COLOR_APP, COLOR_TEXT } from '../../constants'
import { convertCurrentDate } from '../../helpers'

export default function OrderDeliveryStories() {

    // states
    const [cdFillter, setCdFillter] = useState({
        createdAt_gte: '',
        createdAt_lt: '',
    });
    const [isCurrentModals, setIsCurrentModals] = useState(false);
    const [activeButton, setActiveButton] = useState("thisYear");


    return (
        <React.Fragment>
            <Card style={{ border: 'none', boxShadow: 'none', width: '100%' }}>
                <Card.Header>ລາຍງານສະຕ໋ອກສິນຄ້າໃນຮ້ານ</Card.Header>
                <Card.Body>
                    <Card.Title>ລາຍການສິນຄ້າ: 0 </Card.Title>
                    <Card.Title>ລວມຈຳນວນສິນຄ້າທັງໝົດ: 0</Card.Title>
                    <Card.Text>
                        ຈັດການສິນຄ້າ ລາຍລະອຽດສິນຄ້າ ແລະ ຄວບຄຸມສະຕ໊ອກຂອງສິນຄ້າລວມຂອງຮ້ານທັງຫມົດ
                    </Card.Text>
                    <div style={{ display: "flex", flexDirection: "row", gap: 10 }}>
                        <Form.Group className="mb-3 w-100" controlId="exampleForm.ControlInput1">
                            <Form.Label>ຄົ້ນເລກ tracking</Form.Label>
                            <Form.Control type="text" placeholder="Tracking number..." />
                        </Form.Group>
                        <div style={{ minWidth: 240 }}>
                            <Form.Label>ວັນທີ, ເດືອນ, ປີ</Form.Label>
                            <Button
                                variant="outline-secondary"
                                onClick={() => setIsCurrentModals(true)}
                                style={{ width: "100%", display: 'flex', gap: 5, justifyContent: 'space-between', alignItems: 'center' }}

                            >
                                <MdDateRange style={{ fontSize: 25 }} />
                                {_.isEmpty(cdFillter) ? (
                                    "mm/dd/yyyy"
                                ) : (
                                    <>
                                        {convertCurrentDate(cdFillter?.createdAt_gte) + "-" + convertCurrentDate(cdFillter?.createdAt_lt)}
                                    </>
                                )}
                            </Button>
                        </div>
                    </div>
                </Card.Body>
            </Card>

            <DeliveryLists />


            {/* current date modal */}

            <CurrentDateModal
                onCloseModal={() => setIsCurrentModals(false)}
                openModal={isCurrentModals}
                setCdFillter={setCdFillter}
                setActiveButton={setActiveButton}
                activeButton={activeButton}
                backdrop={true}

            />

        </React.Fragment>
    )
}
